import moment from "moment";
import { useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { validateToken, callApi } from "../../../lib/utils";
import CustomLoader from "../../GenericComponents/CustomLoader";
import "./SafeLocationAlerts.css";
import store from "../../../reducers/store";
import GenericTableFilterBar from "../../GenericComponents/GenericTableFilterBar";
import SafeLocationAlertsHeader from "./SafeLocationAlertsHeader";
import SafeLocationAlertsList from "./SafeLocationAlertsList";
import "../DrillDownPage.css";

function SafeLocationAlerts() {
  const pages = useSelector((state) => state?.appstate?.pages);
  const [searchList, setSearchList] = useState([]);
  const [safeLocationAlertsList, setSafeLocationAlertsList] = useState([]);
  const profileData = useSelector((state) => state?.dashboard);
  const [loading, setLoading] = useState(false);
  const currentPage = useSelector((state) => state?.tableFilter?.currentPage);
  const perPage = useSelector((state) => state?.tableFilter?.perPage);
  const startDate = useSelector((state) => state?.globalFilters?.startDate);
  const endDate = useSelector((state) => state?.globalFilters?.endDate);

  useEffect(() => {
    if (profileData?.profileData?.id) {
      validateToken((err) => {
        if (err) {
          // console.log(err);
          window.location = "/logout";
        }
        fetchData();
      });
    }
  }, [perPage, currentPage]);

  const setPagination = (data) => {
    store.dispatch({ type: "SET_PAGINATION_PAGES", payload: { pages: data } });
  };

   const fetchData = () => {
    let params = {
      patientId: profileData?.profileData?.id,
      // eventType: 9,
      start: startDate,
      timezone: moment.tz.guess(),
      end: endDate,
      page: currentPage,
      limit: parseInt(perPage)
    };
    setLoading(true);
    callApi(`/api/patient/dashboard/safe-location-alert/list/${params.patientId}`, params, "POST")
      .then((response) => {
        setSafeLocationAlertsList(response?.data?.data?.safeLocationAlerts);
        setSearchList(response?.data?.data?.safeLocationAlerts);
        setPagination(response?.data?.data?.pagination?.pages);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  };

  const filterRecordsBySearchText = (searchText) => {
    let filteredList = [];
    searchList.forEach((list) => {
      let shouldAdd = true;
      if (
        list.recordId.toUpperCase().search(searchText.toUpperCase()) ===
        -1
      ) {
        shouldAdd = false;
      }

      if (shouldAdd) {
        filteredList.push(list);
      }
    });
    setSafeLocationAlertsList(filteredList);
  };

  return (
    <div className="drilldown-page">
      <CustomLoader loading={loading} />
      <SafeLocationAlertsHeader />
      <GenericTableFilterBar pages={pages} title="" filterRecordsBySearchText={filterRecordsBySearchText} />
      <SafeLocationAlertsList currentPage={currentPage} perPage={perPage} safeLocationAlertsList={safeLocationAlertsList} />
    </div>
  );
}

export default SafeLocationAlerts;
